import React, { useEffect, useState } from 'react';
import {
  HandleWrapper,
  Content,
  Text,
  Form,
  Input,
  ButtonWrapper,
  ButtonHandle,
} from './index.styles';

import PropTypes from 'prop-types';
import axios, { HANDLE } from '../../utils/api';
import messageBanner from '@components/reusable/messageBanner';
import { useDispatch } from 'react-redux';
import { setUserId, setUserInfo } from '@redux/auth/authSlice';
import { useRouter } from 'next/router';

export default function HandleModal({ isSpinning }) {
  const [handle, setHandle] = useState('');
  const handleHandle = (e) => {
    if (e.target.value.length < 31) {
      setHandle(e.target.value.replace(/\s/g, '').replace('@', ''));
    }
  };

  const dispatch = useDispatch();
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    isSpinning(true);
    setIsLoading(true);

    try {
      const userID = localStorage.getItem('userid');

      const data = await axios.post(`/users/${userID}${HANDLE}`, {
        handle: handle.toLowerCase(),
      });

      if (data.data.statusCode === 409) {
        messageBanner({
          message: `Handle already taken 😥`,
          status: 'error',
        });
        setHandle('');
        localStorage.removeItem('handle');
      } else {
        localStorage.setItem('handle', data.data.handle);
        dispatch(setUserId(data.data._id));
        dispatch(setUserInfo(data.data));
        localStorage.setItem('new', 'one');
        router.push('/');
        // go to next modal
        // nextModal();
        isSpinning(false);
        setIsLoading(false);
      }
    } catch (error) {
      isSpinning(false);
      setIsLoading(false);

      if (error.response.data.statusCode === 500) {
        messageBanner({
          message: `Something went wrong, please try again later 😥`,
          status: 'error',
        });
      } else if (error.response.data.statusCode === 409) {
        messageBanner({
          message: `Handle already taken 😥`,
          status: 'error',
        });
        setHandle('');
        localStorage.removeItem('handle');
      } else {
        messageBanner({
          message: `Something went wrong, please try again later 😥`,
          status: 'error',
        });
      }
    }
  };

  const [allGood, setAllGood] = useState(false);
  useEffect(() => {
    if (handle.length > 4 || handle.length === 0) {
      setAllGood(true);
    } else {
      setAllGood(false);
    }
  }, [handle]);

  return (
    <HandleWrapper className="h-[15rem]">
      <Content className="h-max">
        <Text className="mb-2">Create your unique handle</Text>
        <Form>
          <Input
            required
            maxLength={15}
            value={handle}
            onChange={(e) => handleHandle(e)}
            placeholder="Your handle"
            allGood={allGood}
          />
          <ButtonWrapper>
            <ButtonHandle
              type="submit"
              disabled={handle.length < 5}
              onClick={(e) => handleSubmit(e)}
              className="bg-white text-black"
            >
              {isLoading ? 'Loading...' : 'Create'}
            </ButtonHandle>
          </ButtonWrapper>
        </Form>
      </Content>
    </HandleWrapper>
  );
}

// proptypes
HandleModal.propTypes = {
  showSuccess: PropTypes.func.isRequired,
  isSpinning: PropTypes.func.isRequired,
  nextModal: PropTypes.func,
};
